import React, { useEffect } from "react";
import { routes } from "@/routes";
import { useAuth } from "@/context/auth";
import { useRoute } from "@/context/router";
import { makeStyles, Spinner } from "@fluentui/react-components";
import api from "../services/api";
import { AppLayout } from "@/components/app-layout";

const useStyles = makeStyles({
  loading: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

export const Router: React.FC = () => {
  const { isAuthenticated, isLoading, logout } = useAuth();
  const { currentRoute } = useRoute();
  const styles = useStyles();

  useEffect(() => {
    const interceptor = api.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          logout();
        }

        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.response.eject(interceptor);
    };
  }, [api]);

  if (isLoading || !currentRoute) {
    return (
      <div className={styles.loading}>
        <Spinner />
      </div>
    );
  }

  const { component: CurrentComponent, isPublic } = routes.find((route) => route.name === currentRoute) || {};

  if (!CurrentComponent) {
    return <div>404 Not Found</div>;
  }

  if (!isAuthenticated && !isPublic) {
    return <div>Unauthorized</div>;
  }

  return (
    <AppLayout isPublic={isPublic}>
      <CurrentComponent />
    </AppLayout>
  );
};
